<template>
    <div class="form-group" :class="{'has-error': error }">
        <label v-if="fieldLabel" :for="name" class="label">{{ fieldLabel }}</label>
        <div class="field-group">
            <treeselect
                v-model="value"
                :options="options"
                placeholder="Kies een categorie..."
                :name="name"
                :default-expand-level="3"
            />
            <Transition name="fade">
                <p v-show="error" class="error">{{ error }}</p>
            </Transition>
        </div>
    </div>
</template>


<script>
    import Treeselect from '@riophae/vue-treeselect';

    export default {
        name: 'ProductCategorySelectInput',
        components: {
            Treeselect,
        },
        props: {
            name: {
                type: String,
                required: true,
            },
            fieldLabel: {
                type: String,
                required: false,
                default: null,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            options: {
                type: [Array, Object],
                required: true,
            },
            error: {
                type: String,
                required: false,
                default: null,
            },
            preSelected: {
                type: Number,
                default: null,
            },
        },
        data() {
            return {
                value: '',
            };
        },
        created() {
            this.value = this.preSelected;
        },
        methods: {
            updateValue(value) {
                this.$emit('input', value);
            },
        },
    };
</script>
